import React, { useEffect, useState } from "react";
import { Form, Image } from "react-bootstrap";
import Plan1 from "../components/Plan1";
import Plan2 from "../components/Plan2";
import Plan3 from "../components/Plan3";
import Plan4 from "../components/Plan4";
import Plan5 from "../components/Plan5";
import Discount from "../components/Discount";
import { INDUSTRY_ENUM_CATEGORY, INDUSTRY_ENUM, CATEGORY } from "../config/const";
import { initialData_plan1 } from "../components/Plan1";
import { initialData_plan2 } from "../components/Plan2";
import { initialData_plan3 } from "../components/Plan3";
import { initialData_plan4 } from "../components/Plan4";
import { initialData_plan5 } from "../components/Plan5";

import { Controller, useFormContext, useWatch } from "react-hook-form";
import { BidFormInput, Facility, Usage } from "../types/type";
import { formatDateForInput } from "../utils/utils";

const BidCondition: React.FC<{ facility: Facility, confirm: boolean }> = ({ facility, confirm }) => {
    const { control, watch, setValue } = useFormContext<BidFormInput>();
    const watchedConditions = useWatch({ name: 'conditions' });
    const penalty = watch(`conditions.${facility.id}.penalty`);
    const is_custom = watch(`conditions.${facility.id}.is_custom`);
    const custom_check_1 = watch(`conditions.${facility.id}.custom_check_1`);
    const custom_check_2 = watch(`conditions.${facility.id}.custom_check_2`);
    const custom_check_3 = watch(`conditions.${facility.id}.custom_check_3`);

    const [planComponent, setPlanComponent] = useState<React.ReactNode>();

    const getNormalUsageDefaultData = (contractType: string) => {
        switch (contractType) {
            case "SEASON":
            case "LOW_LOAD_SEASON":
            case "LOW_LOAD_FIXED":
                return initialData_plan1;
            case "LOAD_FACTOR":
            case "LOW_LOAD_STEP":
                return initialData_plan2;
            case "SEASONAL_HOLIDAYS":
                return initialData_plan3;
            case "SEASON_TIME_ZONE":
            case "LOW_LOAD_TIME":
                return initialData_plan4;
            default:
                return initialData_plan1;
        }
    };

    const getCustomUsageDefaultData = (cehck1: boolean, check2: boolean, check3: boolean) => {
        if (cehck1 && !check2 && !check3) return initialData_plan2;
        if (cehck1 && check2 && !check3) return initialData_plan5;
        if (!cehck1 && !check2 && check3) return initialData_plan4;
        return initialData_plan1;
    };

    const handleCustom = () => {
        if (window.confirm("カスタムすると入力された使用量料金がクリアされます。変更してよろしいでしょうか？")) {
            resetUsage(true, facility.contract_type, custom_check_1, custom_check_2, custom_check_3);
        }
    };

    const handleNormal = () => {
        if (window.confirm("カスタム入力された使用量料金がクリアされます。変更してよろしいでしょうか？")) {
            resetUsage(false, facility.contract_type, false, false, false);
        }
    };

    const resetUsage = (
        isCustom: boolean,
        contractType: string,
        check1: boolean,
        check2: boolean,
        check3: boolean
    ) => {
        const usage = isCustom
            ? getCustomUsageDefaultData(check1, check2, check3)
            : getNormalUsageDefaultData(contractType);

        setValue(`conditions.${facility.id}.usage`, usage ?? [], {
            shouldDirty: true,
            shouldValidate: true,
        });

        setValue(`conditions.${facility.id}.is_custom`, isCustom);
    };

    const handleCustomCheck = (checkName: keyof BidFormInput['conditions'][number], value: boolean) => {
        setValue(`conditions.${facility.id}.${checkName}` as const, value);
    };


    return (
        <div className="p-2 pt-5">
            <div className="bg-ass-08 p-4">
                <input type="hidden" className="facility" />
                <input type="hidden" className="contract_type" />
                <input type="hidden" className="is_custom" />

                <div className="text-center">
                    <Image className="height-80 mt--60 mb-1" src="assets/images/other/icon-clip.svg" />
                </div>
                <div className="text-xs mb-2 fw-400">
                    応札条件 <span className="ml-2 condition-badge" style={{ background: `${facility.category && CATEGORY[facility.category] ? CATEGORY[facility.category]["color"] : "#000000"}` }}>{facility.category && CATEGORY[facility.category] ? CATEGORY[facility.category]["name"] : ""}</span>
                </div>

                <hr className="mt-2" />
                <label className="mb-1">
                    <Image className="height-20 mr-1 mb-1" src="assets/images/other/icon-medal-blue.svg" />
                    入札料金体系
                </label>

                {!is_custom && (
                    <div className="mb-4 normal-type">
                        <div className="border d-inline-block p-2 mr-md-3">
                            <button type="button" className="btn btn-theme btn-outline-success border-success rounded-0 py-2 px-3">
                                希望料金体系
                            </button>
                            <div className="d-inline-block fw-400 pr-4">
                                {facility.category !== 3 && (
                                    <>
                                        <img className="bidding-condition-header-icon mb-1 ml-2" src="assets/images/bidding-condition/default.svg" alt="季節別アイコン" />
                                        <span>季節別</span>
                                    </>
                                )}
                                {facility.category !== 4 && (
                                    <>
                                        <Image
                                            className="bidding-condition-header-icon mb-1 ml-2"
                                            src={
                                                facility.contract_type === "LOAD_FACTOR" || facility.contract_type === "LOW_LOAD_STEP"
                                                    ? "assets/images/bidding-condition/chart-bar-blue.svg"
                                                    : "assets/images/bidding-condition/chart-bar.svg"
                                            }
                                        />
                                        <span className={!(facility.contract_type === "LOAD_FACTOR" || facility.contract_type === "LOW_LOAD_STEP") ? "text-ass-07" : ""}>
                                            {facility.category >= 3 ? "段階型" : "負荷率別"}
                                        </span>
                                    </>
                                )}
                                {facility.category !== 4 && (
                                    <>
                                        <Image
                                            className="bidding-condition-header-icon mb-1 ml-2"
                                            src={
                                                facility.contract_type === "SEASONAL_HOLIDAYS" || facility.contract_type === "LOW_LOAD_FIXED"
                                                    ? "assets/images/bidding-condition/calendar-blue.svg"
                                                    : "assets/images/bidding-condition/calendar.svg"
                                            }
                                        />
                                        <span className={!(facility.contract_type === "SEASONAL_HOLIDAYS" || facility.contract_type === "LOW_LOAD_FIXED") ? "text-ass-07" : ""}>
                                            {facility.category >= 3 ? "定額型" : "曜日別"}
                                        </span>
                                    </>
                                )}
                                {facility.category !== 4 && (
                                    <>
                                        <Image
                                            className="bidding-condition-header-icon mb-1 ml-2"
                                            src={
                                                facility.contract_type === "SEASON_TIME_ZONE" || facility.contract_type === "LOW_LOAD_TIME"
                                                    ? "assets/images/bidding-condition/clock-blue.svg"
                                                    : "assets/images/bidding-condition/clock.svg"
                                            }
                                        />
                                        <span className={!(facility.contract_type === "SEASONAL_HOLIDAYS" || facility.contract_type === "LOW_LOAD_FIXED") ? "text-ass-07" : ""}>
                                            時間別
                                        </span>
                                    </>
                                )}
                            </div>
                        </div>
                        {!confirm && facility.category <= 2 && (
                            <button
                                type="button"
                                className="btn btn-sm btn-theme btn-danger px-3 rounded-pill mb-sm-0 mb-2 custom-button-on"
                                onClick={handleCustom}
                            >
                                入札料金体系をカスタムする
                            </button>
                        )}
                    </div>
                )}

                {is_custom ? (
                    <div className="mb-4 custom-type">
                        <div className="mb-4 clearfix custom-bidstructure">
                            <div className="border d-inline-block p-2 mr-md-3 float-left">
                                <input className="oringal_check_hidden" type="hidden" />
                                <input className="custom_check_hidden custom_check_1_hidden" type="hidden" />
                                <input className="custom_check_hidden custom_check_2_hidden" type="hidden" />
                                <input className="custom_check_hidden custom_check_3_hidden" type="hidden" />
                                <div className="float-left">
                                    <span className="text-theme-primary border-theme-primary rounded-0 py-2 px-3 mr-3 fw-300 d-inline-block">カスタム料金体系</span>
                                </div>
                                <div className="d-inline-block fw-400 pr-lg-5 pr-4">
                                    <div className="form-check form-check-inline">
                                        <Controller
                                            name={`conditions.${facility.id}.custom_check_1`}
                                            control={control}
                                            render={({ field }) => (
                                                <input
                                                    {...field}
                                                    type="checkbox"
                                                    className="form-check-input custom_check_1 custom_check"
                                                    disabled={custom_check_3 || confirm}
                                                    onChange={() => handleCustomCheck("custom_check_1", !custom_check_1)}
                                                    checked={field.value}
                                                />
                                            )}
                                        />
                                        <label className="form-check-label" htmlFor="ICB05">
                                            <Image className="bidding-condition-header-icon mb-1" src="assets/images/bidding-condition/chart-bar-blue.svg" />
                                            負荷率別
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <Controller
                                            name={`conditions.${facility.id}.custom_check_2`}
                                            control={control}
                                            render={({ field }) => (
                                                <input
                                                    {...field}
                                                    type="checkbox"
                                                    className="form-check-input custom_check_2 custom_check"
                                                    disabled={custom_check_3 || confirm}
                                                    onChange={() => handleCustomCheck("custom_check_2", !custom_check_2)}
                                                    checked={field.value}
                                                />
                                            )}
                                        />
                                        <label className="form-check-label" htmlFor="ICB06">
                                            <Image className="bidding-condition-header-icon mb-1" src="assets/images/bidding-condition/calendar-blue.svg" />
                                            曜日別
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <Controller
                                            name={`conditions.${facility.id}.custom_check_3`}
                                            control={control}
                                            render={({ field }) => (
                                                <input
                                                    {...field}
                                                    type="checkbox"
                                                    className="form-check-input custom_check_3 custom_check"
                                                    disabled={custom_check_1 || custom_check_2 || confirm}
                                                    onChange={() => handleCustomCheck("custom_check_3", !custom_check_3)}
                                                    checked={field.value}
                                                />
                                            )}
                                        />
                                        <label className="form-check-label" htmlFor="ICB07">
                                            <Image className="bidding-condition-header-icon mb-1" src="assets/images/other/icon-clock-ass.svg" />
                                            <span className="text-ass-07">時間別</span>
                                        </label>
                                    </div>
                                    <p className="text-red-03 pl-5 ml-5 mb-0">※時間別の同時選択はできません</p>
                                </div>
                            </div>
                            {!confirm && (
                                <div className="float-left">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-theme btn-secondary hover-off px-3 rounded-pill mb-sm-0 mb-2 mt-3 display-to-original-bidstructure custom-button-off"
                                        onClick={handleNormal}
                                    >
                                        希望料金体系に戻す
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                ) : null}

                <div className="row">
                    <div className="col-lg-8 col-md-7">
                        <div className="form-group">
                            <label className="mb-1" htmlFor="formGroupExampleInput">
                                <Image className="img img-fluid height-20 mr-1 mb-1" src="assets/images/other/icon-list-clip-art.svg" />
                                プラン名
                                <Image className="required-icon" src="assets/images/registration/required-icon.svg" />
                            </label>
                            <Controller
                                name={`conditions.${facility.id}.name`}
                                control={control}
                                rules={{
                                    required: { value: true, message: "必須入力" },
                                    validate: (value) => value !== null || "文字を入力してください",
                                }}
                                render={({ field }) => (
                                    <input
                                        className="form-control mb-3 rounded-0 name-required"
                                        {...field}
                                        placeholder="プラン名を入力してください"
                                    />
                                )}
                                disabled={confirm}
                            />
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-5">
                        <div className="form-group">
                            <label className="mb-1 label-charge" htmlFor="formGroupExampleInput2">
                                <span>
                                    <Image className="img img-fluid height-20 mr-1 mb-1" src="assets/images/other/icon-yen-sign-bg-yellow.svg" />
                                    基本料金単価
                                </span>
                            </label>
                            <div className="input-group">
                                <Controller
                                    name={`conditions.${facility.id}.base`}
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            type="number"
                                            step="1"
                                            className="form-control mb-3 rounded-0 name-required text-right"
                                            {...field}
                                            placeholder="基本料金単価を入力してください"
                                        />
                                    )}
                                    disabled={confirm}
                                />
                                <div className="input-group-append">
                                    <Image className="img img-fluid ml-3" width="15" src="assets/images/bidding-condition/kw.svg" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">

                    <div className="col-md-11 pr-lg-5">
                        <div className="row">

                            <div className="col-lg-6 col-md-6" >
                                <div className="form-group">
                                    <label className="mb-1" htmlFor="supplyStartDate">
                                        {/* <Image className="img img-fluid height-20 mr-1 mb-1" src="assets/images/other/icon-list-clip-art.svg" /> */}
                                        予定供給開始日
                                        <Image className="required-icon" src="assets/images/registration/required-icon.svg" />

                                    </label>
                                    <div className="input-group">
                                        <Controller
                                            name={`conditions.${facility.id}.supply_start_date`}
                                            control={control}
                                            rules={{
                                                required: { value: true, message: "必須入力" },
                                                validate: (value) => value !== null || "日付を入力してください",
                                            }}
                                            render={({ field }) => (
                                                <input
                                                    type="date"
                                                    className="form-control mb-3 rounded-0 name-required"
                                                    {...field}
                                                    value={formatDateForInput(field.value)}

                                                />
                                            )}
                                            disabled={confirm}
                                        />
                                    </div>
                                </div>
                            </div>


                            <div className="col-lg-6 col-md-6 ">
                                <div className="form-group">
                                    <label className="mb-1 label-charge" htmlFor="submissionDeadline">
                                        <span>
                                            需給申込書（又はそれらに該当する資料）の提出期限
                                            <Image className="required-icon" src="assets/images/registration/required-icon.svg" />

                                        </span>
                                    </label>
                                    <div className="input-group">
                                        <Controller
                                            name={`conditions.${facility.id}.application_deadline`}
                                            control={control}
                                            render={({ field }) => (
                                                <input
                                                    type="date"
                                                    className="form-control mb-3 rounded-0 name-required"
                                                    {...field}
                                                    value={formatDateForInput(field.value)}

                                                />
                                            )}
                                            disabled={confirm}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-11 pr-lg-5">
                        <div className="table-responsive mb-4">
                            <label htmlFor="formGroupExampleInput2">
                                <Image className="height-20 mr-1 mb-1" src="assets/images/other/icon-line-chart-graph.svg" />
                                使用量料金
                            </label>
                            <div className="table-responsive">
                                <Plan1 facility={facility} confirm={confirm} />
                                <Plan2 facility={facility} confirm={confirm} />
                                <Plan3 facility={facility} confirm={confirm} />
                                <Plan4 facility={facility} confirm={confirm} />
                                <Plan5 facility={facility} confirm={confirm} />
                            </div>
                        </div>
                        <Discount facility={facility} confirm={confirm} />

                        <div className="mb-3 clearfix">
                            <div className="input-group float-left">
                                <span className="input-group-text border-0 bg-transparent pl-0">年間電気料金</span>
                                <Controller
                                    name={`conditions.${facility.id}.annual_bill_total`}
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            type="number"
                                            step="1"
                                            className="form-control rounded-0 text-right w-max-200 abt text-right"
                                            {...field}
                                            placeholder="年間電気料金を入力してください"
                                        />
                                    )}
                                    disabled={confirm}
                                />
                                <div className="input-group-text border-0 bg-transparent">円</div>
                            </div>
                        </div>
                        <div>
                            <label className="mb-1">
                                <Image className="height-20 mr-2 mb-1" src="assets/images/other/icon-page-fold.svg" />
                                契約期間
                            </label>
                            <hr className="mt-1" />
                            <div className="clearfix  mb-3">
                                <div className="input-group w-max-230 float-left mr-lg-5 mr-4 fw-400">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text border-0 bg-transparent pl-0">契約期間</span>
                                    </div>
                                    <Controller
                                        name={`conditions.${facility.id}.contract_term`}
                                        control={control}
                                        disabled={confirm}
                                        render={({ field }) => (
                                            <select {...field} className="custom-select theme-form-select rounded-0 w-min-100 text-right">
                                                {Array.from({ length: 12 }, (_, idx) => (
                                                    <option key={idx} value={idx + 1}>
                                                        {idx + 1}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text border-0 bg-transparent">年</span>
                                    </div>
                                </div>
                                <div className="input-group w-max-400 float-left mb-3">
                                    <span className="input-group-text border-0 bg-transparent">解約申告月</span>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text rounded-0 bg-ass-demo">契約期間満了</span>
                                    </div>
                                    <Controller
                                        name={`conditions.${facility.id}.contract_cancel_by`}
                                        control={control}
                                        disabled={confirm}
                                        render={({ field }) => (
                                            <select {...field} className="custom-select theme-form-select rounded-0 w-min-100 text-right">
                                                {Array.from({ length: 12 }, (_, idx) => (
                                                    <option key={idx} value={idx + 1}>
                                                        {idx + 1}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text border-0 bg-transparent">ヶ月前</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mb-3">
                            <label className="d-inline-block mr-2">違約金の設定 : </label>
                            <div className="form-check form-check-inline">
                                <Controller
                                    name={`conditions.${facility.id}.penalty`}
                                    control={control}
                                    disabled={confirm}
                                    render={({ field }) => (
                                        <input
                                            className="form-check-input ICB01"
                                            {...field}
                                            type="checkbox"
                                            checked={field.value}
                                            disabled={confirm}
                                        />
                                    )}
                                />
                                <label className="form-check-label">有り</label>
                            </div>
                        </div>
                        {true ? (
                            <>
                                <div className="mb-3 clearfix">
                                    <div className="form-check form-check-inline float-left mt-2">
                                        <label className="form-check-label" htmlFor="ICB03">一律金額</label>
                                    </div>
                                    <div className="input-group float-left w-max-200">
                                        <Controller
                                            name={`conditions.${facility.id}.penalty_fee`}
                                            control={control}
                                            disabled={confirm}
                                            render={({ field }) => (
                                                <input
                                                    type="number"
                                                    step="1"
                                                    className="form-control rounded-0 text-right" {...field} />
                                            )}
                                        />
                                        <div className="input-group-text border-0 bg-transparent">円</div>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <div className="form-check form-check-inline">
                                                <label className="form-check-label" htmlFor="ICB04">それ以外</label>
                                            </div>
                                        </div>
                                        <Controller
                                            name={`conditions.${facility.id}.penalty_note`}
                                            control={control}
                                            disabled={confirm}
                                            render={({ field }) => (
                                                <textarea
                                                    {...field}
                                                    className="form-control rounded-0"
                                                    rows={5}
                                                    placeholder={confirm ? '' : "条件を入力してください。"}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BidCondition;
